import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Layout, Button } from '@storable/canaveral-components';
import FormSubmitButton from '../FormSubmitButton';

const propTypes = {
  disabled: PropTypes.bool.isRequired,
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.number.isRequired,
      message: PropTypes.string.isRequired,
    }).isRequired,
  ),
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  success: PropTypes.string,
};

const defaultProps = {
  errors: undefined,
  submitting: undefined,
  success: undefined,
};

const SettingsFooter = ({
  disabled,
  errors,
  onCancel,
  onSubmit,
  submitting,
  success,
}) => (
  <Layout.Footer
    controls={(
      <React.Fragment>
        <Button
          context="neutral"
          disabled={disabled}
          onClick={onCancel}
        >
          Cancel
        </Button>
        <FormSubmitButton
          disabled={disabled}
          onClick={onSubmit}
          submitting={submitting}
          type="button"
        />
      </React.Fragment>
    )}
    feedback={(
      <React.Fragment>
        {success && (
          <Alert context="success" inline>
            {success}
          </Alert>
        )}
        {errors && errors.map(error => (
          <Alert key={error.code} context="danger" inline>
            {error.message}
          </Alert>
        ))}
      </React.Fragment>
    )}
  />
);

SettingsFooter.propTypes = propTypes;
SettingsFooter.defaultProps = defaultProps;

export default SettingsFooter;
